<div class="row">
  <div
    class="col-12"
    *ngFor="let item of showThisQuantity(); let indexOfelement = index"
  >
    {{ getNestedProperty(item, propShow)
    }}<button
      class="btn-more-items"
      [style.color]="color"
      *ngIf="
        item.clicked !== true &&
        this.itemList.length - this.environment.maxShowItemsList >= 1
      "
      (click)="showList(item)"
    >
      +{{ this.itemList.length - this.environment.maxShowItemsList }}
      <u>{{
        this.itemList.length - this.environment.maxShowItemsList <= 1
          ? textInfoSingular
          : textInfoPlural
      }}</u>
    </button>
  </div>
  <div class="col-12" *ngFor="let item of this.listItens">
    {{ getNestedProperty(item, propShow) }}
  </div>
</div>
